import React, { FunctionComponent, useState } from 'react'
import { Col, Popover, Progress, Row, Tooltip } from 'antd'
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { ChangesHistory } from '@mercadoni/gungnir'
import { ItemCounterProps, ItemCounterStates } from './ItemCounter.types'
import { ItemStateColors } from './ItemCounter.constants'

export const ItemCounter: FunctionComponent<ItemCounterProps> = ({
  title = 'Recolección sin iniciar',
  infoTooltipText = 'El total de ordenes está compuesto por artículos pendientes y agregados',
  states = [],
  changes = [],
  noChangesText = 'Sin cambios',
  changesText = 'Historial de cambios',
  historyPlacement = 'leftBottom',
  historyTitle = 'cambios en la orden',
  addedText = 'Agregado',
  removedText = 'Removido',
  rejectedText = 'Rechazado',
  pendingText = 'Pendiente',
  userText = {
    CLIENT: 'Cliente',
    PICKER: 'Picker',
    AGENT: 'Agente',
    DRIVER: 'Driver'
  }
}: ItemCounterProps): JSX.Element => {
  const [historyVisible, setHistoryVisible] = useState(false)

  const getTotalItems = (): number => {
    if (!states || states.length === 0) {
      return 0
    }

    return states
      .map((st) => st.quantity)
      .reduce((previous, current) => {
        if (!previous) {
          return 0
        }

        return previous + current
      })
  }

  const getHistoryTitle = () => {
    return (
      <Row justify='space-between'>
        <Col>{`${changes.length} ${historyTitle}`}</Col>
        <Col>
          <CloseOutlined onClick={() => setHistoryVisible(false)} />
        </Col>
      </Row>
    )
  }

  const getProgressStyle = (state: ItemCounterStates, idx: number) => {
    let flex = `0 0 ${Math.round((state.quantity / getTotalItems()) * 100)}%`
    if (idx === states.length - 1) {
      flex = '1'
    }

    return {
      flex,
      maxWidth: `${Math.round((state.quantity / getTotalItems()) * 10000) / 100}%`
    }
  }

  return (
    <div className='gungnir-item-counter'>
      <Row>
        <Col>
          <h4>{title}</h4>
        </Col>
      </Row>
      <Row gutter={4}>
        {states &&
          states.map((state, idx) => {
            return (
              <Col style={getProgressStyle(state, idx)} key={idx.toString()}>
                <div className='gungnir-item-state'>
                  <Tooltip placement='topRight' title={`${state.quantity} ${state.name}`}>
                    {`${state.quantity} ${state.name}`}
                  </Tooltip>
                </div>
                <Progress percent={100} showInfo={false} strokeColor={ItemStateColors[state.state]} />
              </Col>
            )
          })}
      </Row>
      <Row gutter={8} align='middle' className='gungnir-item-history'>
        <Col className='gungnir-label'>
          {changes && changes.length ? (
            <Popover
              overlayClassName='gungnir-item-history-changes'
              className='gungnir-item-history-label'
              content={
                <ChangesHistory
                  changes={changes}
                  {...{ addedText, removedText, rejectedText, pendingText, userText }}
                />
              }
              placement={historyPlacement}
              arrowPointAtCenter
              title={getHistoryTitle()}
              trigger='click'
              visible={historyVisible}
              onVisibleChange={setHistoryVisible}
            >
              {`${changesText} (${changes.length})`}
            </Popover>
          ) : (
            <span>{noChangesText}</span>
          )}
        </Col>
        <Col>
          <Tooltip title={infoTooltipText}>
            <InfoCircleOutlined className='gungnir-item-history-info' />
          </Tooltip>
        </Col>
      </Row>
    </div>
  )
}
